import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig, translationsRootKey } from '../../../../settings/index';
import Api, { executeAction } from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import { t } from '../../../../i18n';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('workers/:id/job_invites');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, invite } = payload;
    const search = { ...payload, page, pageSize, column, order, filter };

    const result = yield call(sendRequest, api.load, { search, id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
          invite,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, key, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result?.data) {
      if (cb) {
        cb();
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`dash.common.notification.${key}_successfully`, {
            item: t(`${translationsRootKey}.common.constants.talent`),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.PROCESS_ACTION, processAction)]);
}
